/*!
 * Copyright 2019 yangjunbao <yangjunbao@shimo.im>. All rights reserved.
 * @since 2019-07-09 11:56:12
 */
import { __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { callback, preloadMfePlugin, startFmpPrefetch, startMfeLoad } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import DingtalkSDK from '@ekuaibao/sdk-bridge/sdk/dingtalk';
import registerAPI from '../registerAPI';
import { initializeTitle } from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import { initDatafluxRum } from '../dataflux-rum';
import { localCacheSet } from '@ekuaibao/session-info';
import initLogger from '../../logger/initLogger';
import { anonymousUser, initFeatBit, switchFeatBitUser } from '../../lib/featbit';
import { initializeI18n, setStaffDefaultLanguage } from '../i18n-initialize';
import * as SW from '../../lib/swEntrance';
var markPerformance = function (name) {
    if (window.performance && window.performance.mark) {
        window.performance.mark(name);
    }
};
window.__PLANTFORM__ = 'DING_TALK';
initDatafluxRum();
initLogger();
function startup(hash) {
    app.use({
        id: '@hosting',
        onready: function () {
            addNcpcCode();
        }
    });
    if (hash) {
        app.useHistory({
            search: location.search.slice(1),
            initialEntries: [hash]
        });
    }
    callback();
}
function modifierKey(e) {
    var modifier = 0;
    if (e.metaKey) {
        modifier |= 1;
    }
    if (e.ctrlKey) {
        modifier |= 2;
    }
    if (e.altKey) {
        modifier |= 4;
    }
    if (e.shiftKey) {
        modifier |= 8;
    }
    return modifier;
}
window.addEventListener('keydown', function (e) {
    var modifier = modifierKey(e);
    if (e.keyCode === 82 && (modifier === 1 || modifier === 2)) {
        window.location.reload();
    }
});
function redirect() {
    var params = (function () {
        var arr = location.search.slice(1).split('&');
        var obj = {};
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('=');
            obj[arr2[0]] = decodeURIComponent(arr2[1]);
        }
        return obj;
    })();
    if (params.roleDefId) {
        localCacheSet('beforePage', 'dimensionMap', true);
        return "/dimension-map?roleDefId=" + params.roleDefId;
    }
    return '';
}
var init = function () { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                markPerformance('dingtalk-init-start');
                if ('requestIdleCallback' in window) {
                    requestIdleCallback(function () {
                        markPerformance('dingtalk-mfe-preload-start');
                        preloadMfePlugin();
                    }, { timeout: 1000 });
                }
                else {
                    setTimeout(function () {
                        markPerformance('dingtalk-mfe-preload-start');
                        preloadMfePlugin();
                    }, 1000);
                }
                initColors();
                app.container.set('IDeviceType', 'DESKTOP');
                app.container.set('ISMessageEntry', false);
                app.sdk = app.container.get(DingtalkSDK);
                registerHandler();
                markPerformance('dingtalk-sync-init-complete');
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                markPerformance('dingtalk-sdk-init-start');
                return [4, app.sdk.initialize()];
            case 2:
                _a.sent();
                markPerformance('dingtalk-sdk-init-complete');
                markPerformance('dingtalk-parallel-init-start');
                return [4, Promise.all([
                        initPlatformInfo(),
                        initFeatBit(anonymousUser()),
                        initializeI18n()
                    ])];
            case 3:
                _a.sent();
                markPerformance('dingtalk-parallel-init-complete');
                return [4, switchFeatBitUser()];
            case 4:
                _a.sent();
                markPerformance('dingtalk-user-switch-complete');
                return [4, newHomeConfig({ needInitFeatBit: false, needInitI18n: false })];
            case 5:
                _a.sent();
                markPerformance('dingtalk-home-config-complete');
                initRoute();
                startFmpPrefetch();
                startMfeLoad();
                setStaffDefaultLanguage();
                markPerformance('dingtalk-route-init-complete');
                if ('requestIdleCallback' in window) {
                    requestIdleCallback(function () {
                        markPerformance('dingtalk-non-critical-init-start');
                        setNetworkAdapter();
                        initializeTitle();
                        registerAPI();
                        SW.start();
                        markPerformance('dingtalk-non-critical-init-complete');
                    }, { timeout: 1000 });
                }
                else {
                    setTimeout(function () {
                        markPerformance('dingtalk-non-critical-init-start');
                        setNetworkAdapter();
                        initializeTitle();
                        registerAPI();
                        SW.start();
                        markPerformance('dingtalk-non-critical-init-complete');
                    }, 100);
                }
                markPerformance('dingtalk-init-complete');
                return [3, 7];
            case 6:
                e_1 = _a.sent();
                console.error('init error', e_1);
                markPerformance('dingtalk-init-error');
                return [3, 7];
            case 7: return [2];
        }
    });
}); };
var initPromise = null;
export var appDataInitialize = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initPromise = init();
                return [4, initPromise];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
export var bootstrap = function () { return __awaiter(void 0, void 0, void 0, function () {
    var hash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!initPromise) return [3, 2];
                return [4, initPromise];
            case 1:
                _a.sent();
                initPromise = null;
                _a.label = 2;
            case 2:
                hash = redirect();
                return [4, startup(hash)];
            case 3:
                _a.sent();
                return [2];
        }
    });
}); };
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'beta') {
    require('../development');
}
